import React from 'react';

const STYLES = {
  success: {
    bg: 'bg-gray-900',
    icon: 'text-green-400',
    path: 'M5 13l4 4L19 7',
  },
  error: {
    bg: 'bg-red-900',
    icon: 'text-red-300',
    path: 'M6 18L18 6M6 6l12 12',
  },
  info: {
    bg: 'bg-gray-900',
    icon: 'text-blue-400',
    path: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  loading: {
    bg: 'bg-gray-900',
    icon: 'text-blue-400 animate-spin',
    path: null,
  },
};

const Toast = ({ message, visible, type = 'success', linkHref, linkLabel }) => {
  if (!visible) return null;

  const style = STYLES[type] || STYLES.success;

  return (
    <div
      className={`fixed bottom-4 right-4 max-w-sm ${style.bg} text-white px-5 py-3 rounded-lg shadow-2xl animate-fade-in z-50`}
    >
      <div className="flex items-start space-x-2">
        {type === 'loading' ? (
          <svg className={`h-5 w-5 flex-shrink-0 mt-0.5 ${style.icon}`} viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`h-5 w-5 flex-shrink-0 mt-0.5 ${style.icon}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={style.path} />
          </svg>
        )}
        <div className="min-w-0">
          <span className="font-medium text-sm leading-snug block">{message}</span>
          {linkHref && (
            <a
              href={linkHref}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-blue-300 hover:text-blue-200 underline mt-1 inline-block"
            >
              {linkLabel || 'View on BaseScan ↗'}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toast;
